module.exports = __webpack_public_path__ + "assets/img/NPC011.99880c83.png";